// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.resource-availability-content::part(scroll) {
  display: flex;
  flex-direction: column;
}

.resource-overview {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1rem 1rem 0.85rem;
  background: #ffffff;
}

.resource-summary {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 0.8rem;
}

.resource-type-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.05rem;
  min-width: 3.05rem;
  height: 3.05rem;
  color: #111111;
  font-size: 2.8rem;
}

.resource-meta {
  min-width: 0;
  flex: 1;
}

.resource-name {
  overflow: hidden;
  color: #111111;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resource-address {
  display: flex;
  align-items: center;
  min-width: 0;
  margin-top: 0.35rem;
  color: #737373;
  font-size: 0.95rem;
  line-height: 1.25;
}
.resource-address ion-icon {
  flex: 0 0 auto;
  margin-right: 0.25rem;
  color: #ed143d;
  font-size: 0.95rem;
}
.resource-address span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.availability-legend {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1.5rem;
  color: #6d6d6d;
  font-size: 0.95rem;
  line-height: 1;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  gap: 0.55rem;
  white-space: nowrap;
}

.legend-marker {
  width: 0.95rem;
  height: 0.95rem;
  flex: 0 0 0.95rem;
}
.legend-marker.booked {
  background: #ed143d;
}
.legend-marker.available {
  border: 1px dashed #606060;
  background: #ffffff;
}
.legend-marker.off-hours {
  background: #e8e8e8;
}

app-resource-week-calendar {
  display: block;
  flex: 1 1 auto;
  min-height: 0;
}

@media (max-width: 420px) {
  .resource-overview {
    gap: 0.95rem;
    padding: 1rem 0.9rem 0.95rem;
  }
  .resource-summary {
    align-items: flex-start;
    gap: 0.75rem;
  }
  .resource-type-icon {
    width: 3rem;
    min-width: 3rem;
    height: 3rem;
    font-size: 2.7rem;
  }
  .resource-name {
    font-size: 0.9375rem;
  }
  .resource-address {
    margin-top: 0.45rem;
    font-size: 0.75rem;
  }
  .resource-address ion-icon {
    font-size: 0.75rem;
  }
  .availability-legend {
    justify-content: center;
    gap: 1rem;
    overflow-x: auto;
    font-size: 0.75rem;
    scrollbar-width: none;
  }
  .availability-legend::-webkit-scrollbar {
    display: none;
  }
  .legend-marker {
    width: 1.05rem;
    height: 1.05rem;
    flex-basis: 1.05rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/resource-availability/resource-availability.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,OAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AACF;AACE;EACE,cAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AAEE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,0BAAA;EACA,mBAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;;AAOA;EACE,cAAA;EACA,cAAA;EACA,aAAA;AAJF;;AAOA;EACE;IACE,YAAA;IACA,4BAAA;EAJF;EAOA;IACE,uBAAA;IACA,YAAA;EALF;EAQA;IACE,WAAA;IACA,eAAA;IACA,YAAA;IACA,iBAAA;EANF;EASA;IACE,oBAAA;EAPF;EAUA;IACE,mBAAA;IACA,kBAAA;EARF;EAUE;IACE,kBAAA;EARJ;EAYA;IACE,uBAAA;IACA,SAAA;IACA,gBAAA;IACA,kBAAA;IACA,qBAAA;EAVF;EAYE;IACE,aAAA;EAVJ;EAcA;IACE,cAAA;IACA,eAAA;IACA,mBAAA;EAZF;AACF","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.resource-availability-content::part(scroll) {\n  display: flex;\n  flex-direction: column;\n}\n\n.resource-overview {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  padding: 1rem 1rem 0.85rem;\n  background: #ffffff;\n}\n\n.resource-summary {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  gap: 0.8rem;\n}\n\n.resource-type-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.05rem;\n  min-width: 3.05rem;\n  height: 3.05rem;\n  color: #111111;\n  font-size: 2.8rem;\n}\n\n.resource-meta {\n  min-width: 0;\n  flex: 1;\n}\n\n.resource-name {\n  overflow: hidden;\n  color: #111111;\n  font-size: 1.35rem;\n  font-weight: 700;\n  line-height: 1.15;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.resource-address {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  margin-top: 0.35rem;\n  color: #737373;\n  font-size: 0.95rem;\n  line-height: 1.25;\n\n  ion-icon {\n    flex: 0 0 auto;\n    margin-right: 0.25rem;\n    color: #ed143d;\n    font-size: 0.95rem;\n  }\n\n  span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.availability-legend {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: 1.5rem;\n  color: #6d6d6d;\n  font-size: 0.95rem;\n  line-height: 1;\n}\n\n.legend-item {\n  display: inline-flex;\n  align-items: center;\n  min-width: 0;\n  gap: 0.55rem;\n  white-space: nowrap;\n}\n\n.legend-marker {\n  width: 0.95rem;\n  height: 0.95rem;\n  flex: 0 0 0.95rem;\n\n  &.booked {\n    background: #ed143d;\n  }\n\n  &.available {\n    border: 1px dashed #606060;\n    background: #ffffff;\n  }\n\n  &.off-hours {\n    background: #e8e8e8;\n  }\n}\n\napp-resource-week-calendar {\n  display: block;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n@media (max-width: 420px) {\n  .resource-overview {\n    gap: 0.95rem;\n    padding: 1rem 0.9rem 0.95rem;\n  }\n\n  .resource-summary {\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .resource-type-icon {\n    width: 3rem;\n    min-width: 3rem;\n    height: 3rem;\n    font-size: 2.7rem;\n  }\n\n  .resource-name {\n    font-size: 0.9375rem;\n  }\n\n  .resource-address {\n    margin-top: 0.45rem;\n    font-size: 0.75rem;\n\n    ion-icon {\n      font-size: 0.75rem;\n    }\n  }\n\n  .availability-legend {\n    justify-content: center;\n    gap: 1rem;\n    overflow-x: auto;\n    font-size: 0.75rem;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .legend-marker {\n    width: 1.05rem;\n    height: 1.05rem;\n    flex-basis: 1.05rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
